export default __webpack_public_path__ + "static/media/matic.37a2e657.svg";